export const ADMIN_QUERY_ERROR_CODES = [
  "ADMIN_QUERY_PERMISSION_DENIED",
  "ADMIN_QUERY_INVALID_FILTER",
  "ADMIN_QUERY_USER_NOT_FOUND",
  "ADMIN_QUERY_PROJECTION_STALE",
  "ADMIN_QUERY_SOURCE_UNAVAILABLE",
  "ADMIN_QUERY_REDACTION_FAILED",
  "ADMIN_QUERY_INTERNAL_ERROR",
] as const;

export type AdminQueryErrorCode = (typeof ADMIN_QUERY_ERROR_CODES)[number];

export type AdminQueryError = {
  code: AdminQueryErrorCode;
  message: string;
  requestId?: string;
  cause?: unknown;
};

export function isAdminQueryErrorCode(value: unknown): value is AdminQueryErrorCode {
  return typeof value === "string" && ADMIN_QUERY_ERROR_CODES.includes(value as AdminQueryErrorCode);
}

export function isAdminQueryError(value: unknown): value is AdminQueryError {
  if (typeof value !== "object" || value === null) {
    return false;
  }

  const candidate = value as Partial<AdminQueryError>;
  return isAdminQueryErrorCode(candidate.code) && typeof candidate.message === "string";
}
